import _ from 'lodash';

import {aggregationFormChanged, AggregationGate} from '../../index';

import {data$, dataChanged} from './index';

data$
    .on(dataChanged, (state, payload) => {
        const newState = _.cloneDeep(state);
        const id = newState.findIndex((s) => s.identityCode === payload.identityCode);
        if (id === -1) return [...newState, payload];
        newState.splice(id, 1);
        return newState;
    })
    .reset([AggregationGate.close, aggregationFormChanged]);
